<div class="crop-modal-backdrop" [class.crop-modal-sidebar-safe]="sidebarSafe" *ngIf="showCropModal">
  <div class="crop-modal-card" role="dialog" aria-modal="true" aria-label="Crop image" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (keydown.escape)="cancelCropSelection()">
    <div class="crop-modal-header">
      <h3 class="crop-modal-title">Crop Image to Square</h3>
      <p class="crop-modal-subtitle mb-0">
        {{ cropModalFileName }}
      </p>
    </div>

    <div class="crop-preview-shell">
      <div class="crop-preview-canvas" [style.width.px]="cropDisplayWidth" [style.height.px]="cropDisplayHeight">
        <img *ngIf="cropModalImageSrc" [src]="cropModalImageSrc" alt="Image to crop" class="crop-preview-image"
          [style.width.px]="cropDisplayWidth" [style.height.px]="cropDisplayHeight" />
        <div class="crop-selection-square" [style.width.px]="cropSizePixels" [style.height.px]="cropSizePixels"
          [style.left.px]="cropSelectionLeftPixels" [style.top.px]="cropSelectionTopPixels"></div>
      </div>
    </div>

    <div class="crop-controls mt-3">
      <label class="form-label mb-1">Zoom</label>
      <input type="range" class="form-range" min="1" [max]="cropMaxZoom" step="0.05" [value]="cropZoom"
        (input)="onCropZoomChanged($event)" />

      <label class="form-label mb-1 mt-2">Horizontal Position</label>
      <input type="range" class="form-range" [min]="cropCenterXMin" [max]="cropCenterXMax" step="1"
        [value]="cropCenterX" [disabled]="cropCenterXMin === cropCenterXMax" (input)="onCropCenterXChanged($event)" />

      <label class="form-label mb-1 mt-2">Vertical Position</label>
      <input type="range" class="form-range" [min]="cropCenterYMin" [max]="cropCenterYMax" step="1"
        [value]="cropCenterY" [disabled]="cropCenterYMin === cropCenterYMax" (input)="onCropCenterYChanged($event)" />

      <div class="text-secondary small mt-2">
        Output: {{ cropOutputSize }} x {{ cropOutputSize }} px
      </div>
    </div>

    <div class="d-flex justify-content-end gap-2 mt-4">
      <button type="button" class="btn btn-secondary" [disabled]="cropIsApplying"
        (click)="cancelCropSelection()">
        Cancel Upload
      </button>
      <button type="button" class="btn btn-primary" [disabled]="cropIsApplying" (click)="confirmCropSelection()">
        {{ cropIsApplying ? 'Applying...' : 'Use Cropped Image' }}
      </button>
    </div>
  </div>
</div>

